import {getAuthorizationHeader, preparePostFormBody} from "./repositoryHelper";
import { search } from "../constants/endpoints";

const getSearch = (searchValue) => {
  return fetch(`${search}?q=${searchValue}`, {
    method: "GET",
    headers: {
      ...getAuthorizationHeader(),
    },
  });
};

const markInteraction = (data) => {
  return fetch(`${search}mark_interaction/`, {
    method: "POST",
    headers: {
      ...getAuthorizationHeader(),
    },
    body: preparePostFormBody(data),
  });
};

export const searchRepository = {
  getSearch,
  markInteraction,
};
